import { render, staticRenderFns } from "./tourFilters.vue?vue&type=template&id=19bc17ca"
import script from "./tourFilters.vue?vue&type=script&lang=js"
export * from "./tourFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports